// extracted by mini-css-extract-plugin
export default {"link":"Footer_link__e5-Fl","white":"Footer_white__yxgVx","whiteBold":"Footer_whiteBold__YYk5j"};